import React from 'react'
import { Text, Flex, Box } from '@sitewerk/juraholzbau-design-system'

export type SingleQuoteProps = {
  from: string
  text: string
}

export const SingleQuote: React.FC<SingleQuoteProps> = ({ from, text }) => (
  <Flex
    data-component="quote"
    flexDirection={['column', null, null, 'row']}
    alignItems={['flex-start', null, null, 'flex-end']}
    mb={4}
  >
    <Box width={[1, null, null, 3 / 4]}>
      <Text
        m={0}
        lineHeight="1.2"
        fontWeight={600}
        fontSize={4}
        fontFamily="default"
      >
        {text}
      </Text>
    </Box>

    <Box width={1 / 4}>
      <Text m={0} my={3} fontSize={0} ml={[0, 0, 0, 4]} textColor="neutral.500">
        {from}
      </Text>
    </Box>
  </Flex>
)
